<template>
  <Viewer
    class="prepare-exam"
    :isOpenBookCats="false"
    :valOpenSidebar="typeOpenSidebar"
    :linkBack="{ name:'examAdd', params: {id: examId} }"
    :hideFooter="true"
    :hideGuideUse="true"
  >
    <template v-if="examInfo" v-slot:viewer_head_name>{{ examInfo.name }}</template>
    <template v-if="examInfo" v-slot:viewer_head_right></template>
    <template v-slot:viewr_body>
      <div class="container-hts">
         <b-tabs class="book-detail__tabs tabs-viewer tabs-tooltip text-center">
            <b-tab class="book-detail__tab" >
              <template v-slot:title>
                <span v-b-tooltip.hover>Đề thi / Bài kiểm tra</span>
              </template>
              <div id="prepare_question_view" class="prepare-exam__questions-view">
                <QuestionView />
              </div>
          </b-tab>
          <b-tab>
              <template v-slot:title>
                <span v-b-tooltip.hover>Đáp án</span>
              </template>
              <QuestionCorrectView :dataSource="questionsCorrectAnswer" />
          </b-tab>
        </b-tabs>
      </div>
    </template>
   <!--  <template v-slot:viewer_sidebar_icon>
      <a href="javascript:;" :class="{'active': keySidebarActive === 'info'}" @click="openSidebar('info')">
        <i class="icon-link font-size-24"></i>
      </a>
      <a href="javascript:;" @click="handleDownloadFiles">
        <i class="icon-download font-size-20"></i>
      </a>

    </template> -->
    <template v-slot:viewer_sidebar_content>
      <div class="sidebar-link" v-if="keySidebarActive === 'info'">
        <div class="sidebar__link__result">
          <div class="book-viewer__sidebar__contents__wrap">
            <vueCustomScrollbar v-if="examInfo && examInfo.urlImage" id="preview_book" class="preview-img-exam text-center">
              <img v-for="(item, index) of imagesExam" :id="`item_${index + 1}`" :key="index" :src="item" class="item bg-color-light text-center item-book" alt="Bài kiểm tra">
            </vueCustomScrollbar>
          </div>
        </div>
      </div>
    </template>
    <!-- <template v-slot:viewer_toggle_cat_name></template>
    <template v-slot:viewer_footer_right>
      <a
        href="javascript:;"
        class="btn btn-main border-rd-20 letter-spacing-main line-height-1-2 font-size-16 btn-do-ex"
        :disabled="!examInfo || (examInfo && examInfo.numberQuestion && examInfo.numberQuestion === 0)"
        @click="directToQuestion"
      >
        {{ examInfo && examInfo.isWork === typeExamDone ? 'Xem kết quả' : 'Làm bài' }}
      </a>
    </template>
    <template v-slot:viewer_sidebar_cat_head>
      <h2 class="book-viewer__cats__title primary-color-txt font-size-24 font-sanpro-semibold book-viewer__cats__wrap">
        Thông tin
      </h2>
    </template> -->
    <!-- <template v-slot:viewer_sidebar_cat_body>
      <ExamSidebar :dataSource="examInfo" />
    </template> -->
  </Viewer>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { STORE_KEY } from './../_store/constants'
import { apiDetailExam, apiDownloadExamPdf } from './../_api/exam'
import QuestionView from './../_components/questions/QuestionView.vue'
import QuestionCorrectView from './../_components/questions/QuestionCorrectView.vue'
import Viewer from '@/layouts/Viewer.vue'
import { TYPE_RADIO, TYPE_DOWN_ANSWER } from '@/modules/question/preview-question/_store/constants'
import mixinsFiles from '@/components/content-files/mixinsFiles'
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'ExamView',
  mixins: [ mixinsFiles ],
  components: {
    QuestionView,
    QuestionCorrectView,
    Viewer,
    vueCustomScrollbar
  },
  data () {
    return {
      questionsCorrectAnswer: [],
      keySidebarActive: '',
      apiUrl: APP_CONFIG.appUrl,
      typeOpenSidebar: {},
      imagesExam: []
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['examInfo']),
    
    examId () {
      return parseInt(this.$route.params.id)
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetExamPrepareInfo', 'acSetListQuestions']),

    initPage () {
      let self = this
      apiDetailExam(self.examId).then(res => {
        if (res) {
          self.acSetExamPrepareInfo(res)
          self.acSetListQuestions(res.questions ? res.questions : [])
          self.getAnswerCorrectOfQuestions(res.questions)
          self.setImgsOfExam()
        }
      })
    },

    setImgsOfExam () {
      let self = this
      if (self.examInfo && self.examInfo.urlImage) {
        let imgItem = `${self.apiUrl}${self.examInfo.urlImage}`
        self.imagesExam.push(imgItem)
      }
      if (self.examInfo && self.examInfo.totalpage && self.examInfo.totalpage > -1 && self.examInfo.urlImage) {
        let extention = self.examInfo.urlImage.substring(self.examInfo.urlImage.length - 4, self.examInfo.urlImage.length)
        let urlBefore = self.examInfo.urlImage.slice(0, self.examInfo.urlImage.length - 5)
        for (let i = 2; i <= self.examInfo.totalpage; i++) {
          let item = `${self.apiUrl}${urlBefore}${i}${extention}`
          self.imagesExam.push(item)
        }
      }
    },

    getAnswerCorrectOfQuestions (questions = []) {
      let self = this
      if (questions && questions.length > 0) {
        let dataQuestion = JSON.stringify(questions)
        dataQuestion = JSON.parse(dataQuestion)
        self.questionsCorrectAnswer = dataQuestion
        questions.map((que, index) => {
          if (que.answers && que.type !== TYPE_DOWN_ANSWER) {
            self.questionsCorrectAnswer[index].answers = []
            que.answers.map(ans => {
              ans.correct && self.questionsCorrectAnswer[index].answers.push(ans)
            })
          }
        })
      }
    },

    handleDownloadFiles () {
      this.examInfo.urlPDF && this.downloadDocs(`${this.apiUrl}/${this.examInfo.urlPDF}`, this.examInfo.name, true)
    },

    openSidebar(type) {
      if(type !== null){
        this.typeOpenSidebar = {type, isOpen: type === this.keySidebarActive ? false : true}
        this.keySidebarActive = type !== this.keySidebarActive ? type : ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-noti{
    height: 50vh;
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 0;
}
.prepare-exam__questions-view {
  // border: 1px solid $color_border_main;
  margin-top: 50px;
}
.preview-img-exam {
  height: 82vh;

  img {
    margin-bottom: 15px;
  }
}
</style>
